import axiosInstance from '@/api/axiosInstance';
import { buildQueryString } from '@/utils/query';
import { ExportFormat } from '@/constants/export-dropdown.constants';
import { AuditLog, AuditLogFilterParams, PaginatedAuditLogsResponse, ImpersonationTokens } from '@/types/audit.types';
import { AUDIT_ENDPOINTS, IMPERSONATION_ENDPOINTS } from '@/api/endpoints/audit.endpoints';
import { ManagementApiService } from '@/types/management.types';

import { tr } from '@/i18n';
export const AuditLogManagementApiService: ManagementApiService<AuditLog, AuditLogFilterParams> = {
  getAll: async (offset = 0, limit = 20, filters?: AuditLogFilterParams): Promise<PaginatedAuditLogsResponse> => {
    const query = buildQueryString({ ...filters, offset, limit });
    return (await axiosInstance.get<PaginatedAuditLogsResponse>(`${AUDIT_ENDPOINTS.LOGS}${query}`)).data;
  },
  deleteItem: async (): Promise<void> => {
    return Promise.reject(new Error(tr("ui.audit_logs_deletion_is_not_allowed", "Audit logs deletion is not allowed.")));
  },
  exportItems: async (format: ExportFormat, filters?: Omit<AuditLogFilterParams, 'offset' | 'limit'>): Promise<Blob> => {
    const query = buildQueryString({ ...filters, format: format.toLowerCase() });
    return (await axiosInstance.get<Blob>(`${AUDIT_ENDPOINTS.EXPORT}${query}`, { responseType: 'blob' })).data;
  },
};

export const ImpersonationApi = {
  loginAs: async (userId: number | string): Promise<ImpersonationTokens> =>
    (await axiosInstance.post<ImpersonationTokens>(IMPERSONATION_ENDPOINTS.LOGIN_AS(userId))).data,
  returnToAccount: async (): Promise<ImpersonationTokens> =>
    (await axiosInstance.post<ImpersonationTokens>(IMPERSONATION_ENDPOINTS.RETURN)).data,
};

export const AuditApi = {
  Management: AuditLogManagementApiService,
  Impersonation: ImpersonationApi,
};